import { render } from "./FormJadid.vue?vue&type=template&id=518f4ee0&scoped=true"
import script from "./FormJadid.vue?vue&type=script&lang=js"
export * from "./FormJadid.vue?vue&type=script&lang=js"

import "./FormJadid.vue?vue&type=style&index=0&id=518f4ee0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-518f4ee0"

export default script